<div class="wrapper" [ngClass]="className">
	<div class="title">
		@if (menu.translateName || overrideTranslateName) {
		<h2>{{(overrideTranslateName ||'CUSTOMIZER.COMPONENTS.' + menu.translateName + '.NAME') | translate}}</h2>
		}

		@if (menu.translateDescription && showTranslateDecription) {
		<div class="description" [innerHTML]="menu.translateDescription | translate"></div>
		}
	</div>
	<div class="content">
		<ng-content></ng-content>
	</div>
</div>